import type { Infer } from 'superstruct';
import { array, assign, object, omit, partial } from 'superstruct';

import { ViewFacebookCampaignTemplateDto } from '@adflow/shared/data-facebook-ads';

import { historyArrayItem } from '../history-array-item';

import { HistoryFacebookAdSetTemplateDto } from './history-facebook-adset.dto';

export const HistoryFacebookCampaignDto = assign(
	partial(omit(ViewFacebookCampaignTemplateDto, ['updatedAt'])),
	partial(
		object({
			adSetTemplates: array(historyArrayItem(HistoryFacebookAdSetTemplateDto)),
		})
	)
);

export type HistoryFacebookCampaignDto = Infer<
	typeof HistoryFacebookCampaignDto
>;
